/**
 * TanStack Query client — SWR-style caching.
 * Uzoqroq staleTime: admin panelda bir xil maʼlumot uchun ortiqcha soʻrovlar kamayadi.
 */
import { QueryClient } from '@tanstack/react-query';

const STALE_TIME_MS = 2 * 60 * 1000;
const GC_TIME_MS = 30 * 60 * 1000;

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: STALE_TIME_MS,
      gcTime: GC_TIME_MS,
      retry: 2,
      retryDelay: (attemptIndex) => Math.min(4000, 400 * 2 ** attemptIndex),
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
    },
  },
});
